import { render } from "./SectionTwo.vue?vue&type=template&id=275c2a61&scoped=true"
import script from "./SectionTwo.vue?vue&type=script&lang=js"
export * from "./SectionTwo.vue?vue&type=script&lang=js"

import "./SectionTwo.vue?vue&type=style&index=0&id=275c2a61&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275c2a61"]])

export default __exports__